import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, dark = false }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={`chapter-${num}`}>
      <span
        className={`font-body text-xs font-bold tracking-[0.25em] uppercase ${
          dark ? "text-gold" : "text-terra"
        }`}
      >
        N°{num}
      </span>
      <span className={`h-px w-12 ${dark ? "bg-sand/30" : "bg-ink/20"}`} />
      <span
        className={`font-body text-xs font-semibold tracking-[0.25em] uppercase ${
          dark ? "text-sand/70" : "text-ink/50"
        }`}
      >
        {label}
      </span>
    </div>
  </Reveal>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
    <motion.span
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
      className={`block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);
